import axios from "axios";

export type ArmatekaSubject = {
  id: number;
  name: string;
  image: string;
  view_count: number;
};

const fetchArmatekaSubjects = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_BACKEND_URL}/armateka/subject/all`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    }
  );
  return response.data;
};
const addNewArmatekaSubject = async (
  data: Pick<ArmatekaSubject, "name" | "image">
): Promise<ArmatekaSubject> => {
  const response = await axios.postForm(
    `${process.env.REACT_APP_BACKEND_URL}/armateka/subject`,
    data,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      formSerializer: {
        indexes: null,
      },
    }
  );
  return response.data;
};
const updateArmatekaSubject = async (
  data: Pick<ArmatekaSubject, "name" | "id" | "image">
) => {
  const response = await axios.putForm(
    `${process.env.REACT_APP_BACKEND_URL}/armateka/subject`,
    data,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      formSerializer: {
        indexes: null,
      },
    }
  );
  return response.data;
};
const removeArmatekaSubject = async (id: number) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BACKEND_URL}/armateka/subject`,
    {
      params: { id: id },
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    }
  );
  return response.data;
};

export {
  fetchArmatekaSubjects,
  addNewArmatekaSubject,
  removeArmatekaSubject,
  updateArmatekaSubject,
};
